// extracted by mini-css-extract-plugin
module.exports = {"content-about-wrapper":"ContentAbout_content-about-wrapper__lANAH","description":"ContentAbout_description__sDIxb"};